module.exports = __webpack_public_path__ + "static/media/IMG_2570.f5e87a5e.jpg";